import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { Box, ButtonStyled } from '@nike/nike-design-system-components';
import { CaretLeft } from '@nike/nike-design-system-icons';

import { H1 } from './Headers';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

const PageHeader = ({ page, title, back, className, children, linkBack: { url, linkTitle } = {} }) => {
  const headerTitle = typeof title === 'string' ? new TranslatedCopy({ id: title }).toString() : title;
  return (
    <div className={classnames('page-header bg-white', className)}>
      {url && linkTitle && (
        <Box paddingBlockEnd='18px' style={{ marginLeft: '-5px' }}>
          <Link to={url}>
            <ButtonStyled type='button' appearance='text' background='light' size='large'>
              <CaretLeft size='s' />
              <span className='ml1-sm'>{linkTitle}</span>
            </ButtonStyled>
          </Link>
        </Box>
      )}
      <H1 className={classnames('page-header__title flex-fill', { 'page-title-has-back': back })}>
        {back || null}
        <span data-desc={`${page}__pageHeader`}>{headerTitle}</span>
      </H1>
      {React.Children.count(children) ? <div className='flex-static'>{children}</div> : null}
    </div>
  );
};

PageHeader.defaultProps = {
  page: '',
  back: null,
  children: null,
  className: '',
  linkBack: {}
};

PageHeader.propTypes = {
  page: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  back: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  linkBack: PropTypes.object
};

export default PageHeader;
